@use '@lib/assets/styles/main.scss' as *;

.root {
  border-radius: 10px;
  border: 1px solid $warning900;
  background: $gray0;
  padding: 16px 24px;
  display: grid;
  grid-column-gap: 16px;
  align-items: center;
  @include responsive($md1) {
  grid-template-columns: min-content minmax(0, auto) min-content;
  }
  @include responsive(null, $md1) {
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows:  min-content min-content;
  }
}


.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #FFF;
  background: linear-gradient(225deg, #FFF 0%, #FFF3DF 100%);
  box-shadow: 0 1px 3px 1px rgba(255, 165, 31, 0.15), 0 1px 3px 1px rgba(255, 165, 31, 0.15);
  width: 48px;
  height: 48px;
  svg {
    display: block;
    width: 28px;
    height: 28px;
  }
}

.button {
  @include responsive(null, $md1) {
    grid-row: 1 / 2;
    grid-column: 2 / 3;
    justify-self: end;
  }
}

.content {
  display: block;
  @include responsive(null, $md1) {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
  }
}

.text {
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.desc {
  color: $gray400;
}
